/**
 * Sekcja "Per sklep" - tabela `per_sklep` z podsumowania (ANEKS 1).
 * Klik w wiersz ustawia filtr sklepu (+ filtr "brak"); nieznany adres
 * (sklep_id null) wyrozniony kolorem warning i filtrowany jako sklep_id=0.
 */
import React from 'react';
import { formatujKwote, SKLEP_NIEZNANY_ID } from './format';

const th = { padding: '5px 8px', textAlign: 'left', borderBottom: '2px solid var(--border)', fontSize: '11px', fontWeight: 600, color: 'var(--text-secondary)', whiteSpace: 'nowrap' };
const td = { padding: '4px 8px', borderBottom: '1px solid var(--border)', fontSize: '11px' };
const prawa = { ...td, textAlign: 'right' };
const brakStyl = (n) => ({ ...prawa, fontWeight: 600, color: n > 0 ? 'var(--danger)' : 'var(--success)' });

/** Id do filtra /lista: null w per_sklep = nieznany adres = 0. */
export const idFiltraSklepu = (w) => (w?.sklep_id === null || w?.sklep_id === undefined ? SKLEP_NIEZNANY_ID : w.sklep_id);

const PerSklep = ({ perSklep, aktywnySklepId, onWybierz }) => {
  const lista = Array.isArray(perSklep) ? perSklep : [];
  return (
    <div className="card" data-testid="per-sklep" style={{ fontSize: '12px' }}>
      <h3 style={{ margin: '0 0 8px', fontSize: '13px', fontWeight: 600 }}>Per sklep (wg adresu dostawy z SFD)</h3>
      {lista.length === 0 ? (
        <div style={{ color: 'var(--text-muted)', fontSize: '11px' }}>Brak danych — adresy dostawy pojawią się po synchronizacji</div>
      ) : (
        <div style={{ overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={th}>Sklep</th>
                <th style={{ ...th, textAlign: 'right' }}>W portalu</th>
                <th style={{ ...th, textAlign: 'right' }}>W systemie</th>
                <th style={{ ...th, textAlign: 'right' }}>Brak faktur</th>
                <th style={{ ...th, textAlign: 'right' }}>Brutto brakujących</th>
                <th style={{ ...th, textAlign: 'right' }}>Brak korekt</th>
                <th style={{ ...th, textAlign: 'right' }}>Zły sklep</th>
              </tr>
            </thead>
            <tbody>
              {lista.map((w, idx) => {
                const nieznany = w.sklep_id === null || w.sklep_id === undefined;
                const id = idFiltraSklepu(w);
                const aktywny = aktywnySklepId !== null && aktywnySklepId !== undefined && aktywnySklepId === id;
                return (
                  <tr
                    key={`${id}-${w.nazwa || idx}`}
                    data-testid="per-sklep-wiersz"
                    role="button"
                    tabIndex={0}
                    title="Kliknij, żeby pokazać brakujące faktury tego sklepu"
                    onClick={() => onWybierz && onWybierz(id, w)}
                    onKeyDown={(e) => { if (onWybierz && (e.key === 'Enter' || e.key === ' ')) onWybierz(id, w); }}
                    style={{
                      cursor: 'pointer',
                      backgroundColor: aktywny ? 'var(--primary-light)' : (nieznany ? 'var(--warning-light)' : 'transparent'),
                    }}
                  >
                    <td style={{ ...td, fontWeight: 600, color: nieznany ? 'var(--warning)' : 'var(--text)', whiteSpace: 'nowrap' }}>{w.nazwa || '—'}</td>
                    <td style={prawa}>{w.w_portalu ?? '—'}</td>
                    <td style={prawa}>{w.w_systemie ?? '—'}</td>
                    <td style={brakStyl(w.brak_faktur)}>{w.brak_faktur ?? '—'}</td>
                    <td style={{ ...prawa, whiteSpace: 'nowrap' }}>{formatujKwote(w.brutto_brak_faktur)}</td>
                    <td style={brakStyl(w.brak_korekt)}>{w.brak_korekt ?? '—'}</td>
                    <td style={{ ...prawa, fontWeight: 600, color: w.zly_sklep > 0 ? 'var(--warning)' : 'var(--text-muted)' }}>{w.zly_sklep ?? '—'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PerSklep;
